import { render, staticRenderFns } from "./authenticate-view.vue?vue&type=template&id=47a7a087&scoped=true&"
import script from "./authenticate-view.vue?vue&type=script&lang=js&"
export * from "./authenticate-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a7a087",
  null
  
)

export default component.exports